<template>
  <profile-settings />
</template>

<script>
import ProfileSettings from "@/components/3pl/Settings/Home/index";
export default {
  components: {
    ProfileSettings,
  },
};
</script>
